import React, { useState, useEffect } from 'react'
import { Form, Input, Button, InputNumber, message } from 'antd'
import { createCategory, updateCategory } from '../../api/store'

const CategoryForm = ({ category, onSuccess, onCancel }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const isEditMode = !!category

  useEffect(() => {
    if (category) {
      form.setFieldsValue({
        name: category.name || '',
        description: category.description || '',
        sortOrder: category.sortOrder || 0
      })
    } else {
      form.resetFields()
    }
  }, [category, form])

  const handleFinish = async (values) => {
    setLoading(true)
    try {
      if (isEditMode) {
        await updateCategory(category._id, values)
        message.success('分類更新成功')
      } else {
        await createCategory(values)
        message.success('分類新增成功')
        form.resetFields()
      }
      onSuccess?.()
    } catch (error) {
      message.error(isEditMode ? '分類更新失敗' : '分類新增失敗')
    }
    setLoading(false)
  }

  return (
    <Form form={form} onFinish={handleFinish} layout='vertical'>
      <Form.Item
        name='name'
        label='分類名稱'
        rules={[{ required: true, message: '請輸入分類名稱' }]}
      >
        <Input placeholder='請輸入分類名稱' />
      </Form.Item>
      <Form.Item name='description' label='描述'>
        <Input.TextArea placeholder='請輸入分類描述（可選）' rows={3} />
      </Form.Item>
      <Form.Item name='sortOrder' label='排序順序'>
        <InputNumber placeholder='排序順序' min={0} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          {onCancel && <Button onClick={onCancel}>取消</Button>}
          <Button type='primary' htmlType='submit' loading={loading}>
            {isEditMode ? '確認更新' : '確認新增'}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}

export default CategoryForm
